import styled, { css } from 'styled-components';

export const ModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s6};
    padding: ${theme.sz.s8};

    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s4};
      padding: ${theme.sz.s4};
    }
  `,
);

export const ModalBody = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.co.secondary20};
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s3};
    ${theme.typography.heading.desktop.m};

    @media (max-width: ${theme.sz.md}) {
      margin-bottom: ${theme.sz.s2};
      ${theme.typography.heading.mobile.xs};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.l};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);

export const ModalFooter = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.sz.s3};

    @media (max-width: ${theme.sz.md}) {
      flex-direction: column;
    }
  `,
);

export const ButtonWrapper = styled.div(
  () => css`
    flex-grow: 1;
    flex-basis: 50%;
  `,
);

export const PrimaryButtonContent = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.sz.s2};

    svg {
      font-size: ${theme.sz.s6};
    }
  `,
);

export const ProgressIndicator = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary50};
    text-align: center;

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);
